import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Paper,
} from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(0.25),
    boxShadow: "none",
  },
  formControl: {
    minWidth: 120,
    width: "100%",
  },
  textField: {
    width: "100%",
  },
  filterContent: {
    padding: theme.spacing(0.5),
  },
  toggleContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(1),
  },
  toggleButtonGroup: {
    height: 32,
    width: "100%",
  },
  toggleButton: {
    padding: theme.spacing(0.5, 1.5),
    fontSize: "0.75rem",
    fontWeight: 500,
    textTransform: "none",
    border: `1px solid ${theme.palette.divider}`,
    flex: 1,
    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  dateFields: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  dateField: {
    flex: 1,
  },
}));

const DateRangeFilter = ({ 
  onFiltered, 
  isExpanded = true, 
  onDateChange, 
  initialDateRange = { dateStart: "", dateEnd: "" },
  onFilterTypeChange,
  initialFilterType = "createdAt"
}) => {
  const classes = useStyles();
  const [dateStart, setDateStart] = useState(initialDateRange.dateStart || "");
  const [dateEnd, setDateEnd] = useState(initialDateRange.dateEnd || "");
  const [filterType, setFilterType] = useState(initialFilterType);

  const handleDateStartChange = (event) => {
    const value = event.target.value;
    setDateStart(value);
    // Notificar o componente pai sobre a mudança
    if (onDateChange) {
      onDateChange({ dateStart: value, dateEnd, filterType });
    }
  };

  const handleDateEndChange = (event) => {
    const value = event.target.value;
    setDateEnd(value);
    // Notificar o componente pai sobre a mudança
    if (onDateChange) {
      onDateChange({ dateStart, dateEnd: value, filterType });
    }
  };

  const handleFilterTypeChange = (event, newFilterType) => {
    if (newFilterType !== null) {
      setFilterType(newFilterType);
      
      // Notificar o componente pai sobre a mudança do tipo de filtro
      if (onFilterTypeChange) {
        onFilterTypeChange(newFilterType);
      }
      
      // Notificar também sobre a mudança de data com o novo tipo
      if (onDateChange) {
        onDateChange({ dateStart, dateEnd, filterType: newFilterType });
      }
    }
  };

  return (
    <Paper className={classes.root}>
      <div className={classes.filterContent}>
        <div className={classes.toggleContainer}>
          <ToggleButtonGroup
            value={filterType}
            exclusive
            onChange={handleFilterTypeChange}
            className={classes.toggleButtonGroup}
            size="small"
          >
            <ToggleButton value="createdAt" className={classes.toggleButton}>
              Primeira Mensagem
            </ToggleButton>
            <ToggleButton value="updatedAt" className={classes.toggleButton}>
              Última Mensagem
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        
        <div className={classes.dateFields}>
          <TextField
            className={`${classes.textField} ${classes.dateField}`}
            label="Data Início"
            type="date"
            value={dateStart}
            onChange={handleDateStartChange}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              max: dateEnd || undefined,
            }}
            size="small"
          />
          <TextField
            className={`${classes.textField} ${classes.dateField}`}
            label="Data Fim"
            type="date"
            value={dateEnd}
            onChange={handleDateEndChange}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: dateStart || undefined,
            }}
            size="small"
          />
        </div>
      </div>
    </Paper>
  );
};

export default DateRangeFilter; 